// src/state/editEvents.js
export const EDIT_CHANGED_EVENT = "veya:edit-changed";

export function emitEditChanged(editId) {
  try {
    window.dispatchEvent(
      new CustomEvent(EDIT_CHANGED_EVENT, { detail: { editId, ts: Date.now() } })
    );
  } catch {}
}